import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { setGlobalLoader } from "../../../redux/slices/globalLoader";
import GlobalLoader from "./globalLoader";
import { setUserType } from "../../../redux/slices/userType";
import { useDispatch, useSelector } from "react-redux";
import Header from "./header";
import { cashRegisterData, generateToken } from '../services/order.service';
import { getSessionKey, QRHeaderStatus, setSessionKey } from "../../../utils/commonfunction";
import { addQrPanelToken, ChargeSettingsDetail } from "../../../redux/slices/qrcodeDetails";
import { getRestaurantSettings } from "../../restaurant/services/profile.services";
import { ORDER_PLATFORM, SOCKET_EVENTS } from "../../../utils/Constants";
import { SOCKET_CLIENT } from "../../../utils/socket";
import { useRef } from "react";

const QrOrderLayout = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const loaderState = useSelector((state) => state.globalLoader);
    const queryParams = new URLSearchParams(window.location.search);
    const restaurant_id = queryParams.get('restaurant_id');
    const table_id = queryParams.get('table_id');
    const base = queryParams.get('base');
    const [token, setToken] = useState(null);
    const [layoutHeight, setLayoutHeight] = useState("100vh");
    const [restaurantDetailChanged, setRestaurantDetailChanged] = useState(false);
    const orderUpdatesNotificationModalOpen = useRef();
    const [notificationMessage, setNotificationMessage] = useState(null);

    const newToken = useSelector((state) => { return state.QrOrderToken.qrPanelToken });
    useEffect(() => {
        setToken(newToken);
    }, [newToken]);

    useEffect(() => {
        const body = document.querySelector('body');
        if (body) {
            body.classList.add('restaurant_inner_body');
        }
    }, []);

    useEffect(() => {
        if (getSessionKey("qr_user_token")) {
            dispatch(addQrPanelToken(getSessionKey("qr_user_token")));
        } else {
            if (base === "web") {
                generateToken({ restaurant_id: restaurant_id, table_id: table_id })
                    .then((response) => {
                        setToken(response?.data?.token);
                        setSessionKey("qr_user_token", response?.data?.token);
                        dispatch(addQrPanelToken(response?.data?.token));
                    })
                    .catch((err) => { console.log(err) });
            }
            else {
                setSessionKey("qr_user_token", queryParams.get('token'));
                dispatch(addQrPanelToken(queryParams.get('token')));
            }
        }

    }, []);


    useLayoutEffect(() => {
        dispatch(setUserType("admin"));
        Promise.all([
            import("../../../assets/qrOrder/css/style.css"),
            import("../../../assets/restaurant/css/style.css"),
        ]).then(() => {
            dispatch(setGlobalLoader(false));
        });
    }, []);
    useEffect(() => {
        setTimeout(() => {
            setLayoutHeight(`${window.innerHeight}px`);
        }, 500);
    }, [location]);

    useMemo(() => {
        let joinRequest = {
            roomID: restaurant_id
        };
        SOCKET_CLIENT.emit('JOIN-USER', joinRequest, (error) => {
            if (error) {
                console.log("*****Socket connection error on JOIN-USER", error);
            }
        });

    }, [location]);

    useMemo(() => {
        SOCKET_CLIENT.on('GET-DATA', async (response) => {
            const eventData = response.data;
            if (response) {
                if (response?.event === SOCKET_EVENTS.RESTAURANT_DETAILS_CHANGED) {
                    console.log("socket event listened")
                    setRestaurantDetailChanged(!restaurantDetailChanged)
                }
                if (response.event === SOCKET_EVENTS.ORDER_CANCELLED) {
                    setNotificationMessage("Your order has been cancelled by the restaurant staff. Please contact the restaurant staff for further details. Please scan again the QR code to place a new order.");
                    orderUpdatesNotificationModalOpen.current.click();
                }
            }
        });
    }, [restaurantDetailChanged]);

    useEffect(() => {
        if (token && token.length > 30) {
            getRestaurantSettings({
                extraHeaders: { Authorization: `Bearer ${token}` }
            })
                .then((response) => {
                    // console.log(response.data);
                    dispatch(ChargeSettingsDetail(response.data));
                })
                .catch((error) => {
                    console.log("Error===>", error);
                });
        }

    }, [token, restaurantDetailChanged]);

    useMemo(() => {
        if (token) {
            cashRegisterData({ _id: restaurant_id }, { token: token }).then((response) => {
                if (response?.data) {
                    const { cashRegisterEntry } = response.data;
                    if (!cashRegisterEntry) {
                        setNotificationMessage("Restaurant is not open now. Please try again after some time.");
                        orderUpdatesNotificationModalOpen.current.click();
                    }
                }
            });
        }

    }, [token]);

    return (
        <>
            {loaderState && token ? (
                <GlobalLoader />
            ) : (
                <div className='mobile-container'>
                    <div className='mobile-container-wraper' style={{ height: layoutHeight }}>
                        <Header />
                        <Outlet />
                    </div>
                </div>
            )}

            {/* Order cancellation notification */}
            {/* Button trigger modal */}
            <button
                type="button"
                className="btn btn-primary d-none"
                data-bs-toggle="modal"
                data-bs-target="#orderUpdatesNotification"
                ref={orderUpdatesNotificationModalOpen}
            >
            </button>
            {/* Modal */}
            <div
                className="modal fade"
                id="orderUpdatesNotification"
                tabIndex={-1}
                aria-labelledby="orderUpdatesNotificationLabel"
                aria-hidden="true"
                data-bs-backdrop="static"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title text-center d-block w-100" id="orderUpdatesNotificationLabel">
                                Warning
                            </h3>
                        </div>
                        <div className="modal-body text-center">
                            <i className="ri-error-warning-fill fs-50 text-primary"></i>
                            {
                                notificationMessage &&
                                <p className="mt-2">{notificationMessage}</p>
                            }
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-primary w-100"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                    window.location.href = "https://www.google.com";
                                }} >
                                Okay
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default QrOrderLayout;
